import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { OnGetData } from '../../../services/dialog.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-delete-asset-version-dialog',
  templateUrl: './delete-asset-version-dialog.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, ButtonDirective],
})
export class DeleteAssetVersionDialogComponent implements OnGetData {
  dialogName = 'delete-asset-version';
  close: (...args) => void;

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40, hasSmallBottomPart: true };
  }

  onGetData(data: unknown, close: (...args) => void) {
    this.close = close;
  }
}
